import { OnboardingNode } from '../types';

import * as defaultVersion from './default';
import * as v8 from './v8';
import * as v99 from './v99';

const withIndex = (nodes: OnboardingNode[]): OnboardingNode[] => {
  return nodes.map((node, index) => ({
    ...node,
    index
  }));
};

export const ONBOARDING_VERSIONS: {
  [key: number]: OnboardingNode[];
} = {
  7: withIndex([
    defaultVersion.FIRST_NAME_NODE,
    defaultVersion.EMAIL_NODE,
    defaultVersion.JURISDICTION_NODE,
    defaultVersion.INSURANCE_TYPE_NODE,
    defaultVersion.INSURANCE_PROVIDER_NODE,
    defaultVersion.PRIMARY_SUBSTANCE_NODE,
    defaultVersion.TREATMENT_PREFERENCE_NODE,
    defaultVersion.RECOVERY_GOAL_NODE,
    defaultVersion.FINAL_DETAILS_NODE,
    defaultVersion.PHONE_NUMBER_NODE,
    defaultVersion.PASSWORD_NODE,
    defaultVersion.HOW_DID_YOU_HEAR_WITH_REFERRAL_DROPDOWN_NODE
  ]),
  8: withIndex([
    v8.FIRST_NAME_NODE,
    defaultVersion.EMAIL_NODE,
    defaultVersion.JURISDICTION_NODE,
    defaultVersion.INSURANCE_TYPE_NODE,
    defaultVersion.INSURANCE_PROVIDER_NODE,
    defaultVersion.PRIMARY_SUBSTANCE_NODE,
    defaultVersion.TREATMENT_PREFERENCE_NODE,
    defaultVersion.RECOVERY_GOAL_NODE,
    defaultVersion.FINAL_DETAILS_NODE,
    defaultVersion.PHONE_NUMBER_NODE,
    defaultVersion.PASSWORD_NODE,
    defaultVersion.HOW_DID_YOU_HEAR_WITH_REFERRAL_DROPDOWN_NODE
  ]),
  99: withIndex([v99.FIRST_NAME_NODE, defaultVersion.EMAIL_NODE, defaultVersion.PASSWORD_NODE])
};

export const MIN_VERSION = Math.min(
  ...Object.keys(ONBOARDING_VERSIONS).map((v) => parseInt(v, 10))
);
